<template>
  <v-dialog v-model="dialog.open" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
    <div class="budget-details">
      <div class="top-bar">
        <div class="right-actions">
          <div class="action mr-1" @click="duplicateBudget()">
            <v-icon size="20px" class="px-1">mdi-content-copy</v-icon>
          </div>
          <div class="action" @click="deleteBudget()">
            <v-icon size="20px" class="px-1">mdi-trash-can-outline</v-icon>
          </div>
        </div>
        <div @click="closeDialog()" class="action">
          <v-icon class="px-1">mdi-arrow-left</v-icon>
        </div>
        <div style="font-size: 20px; margin-top: 15px; margin-left: 5px; float: left; letter-spacing: 1px">ORÇAMENTO</div>
      </div>
      <div class="header">
        <div class="total-value">
          {{ total }}
          <div style="float: right; font-weight: normal; margin-top: 10px; font-size: 18px; opacity: 0.8">
            {{ this.selectedBudget.date ? formatDate(this.selectedBudget.date) : 'Sem data' }}
          </div>
        </div>
        <div class="header-actions">
          <v-btn
            style="width: 70%; float: left; margin-right: 3%; background-color: #fff"
            color="#48B38B"
            elevation="0"
            outlined
            @click="openManageDialog()"
            :disabled="this.selectedBudget.status === 'aprovado'"
            >Editar</v-btn
          >
          <v-btn style="width: 27%; float: left; background-color: #fff" color="#48B38B" elevation="0" outlined disabled
            ><v-icon>mdi-draw-pen</v-icon></v-btn
          >
        </div>
      </div>
      <v-tabs :show-arrows="false" v-model="tab" fixed-tabs background-color="#f8f8f8" color="#48B38B">
        <v-tabs-slider color="#48B38B"></v-tabs-slider>
        <v-tab>
          <v-icon size="26px">mdi-file-document-outline</v-icon>
        </v-tab>
        <v-tab>
          <v-icon>mdi-car-multiple</v-icon>
        </v-tab>
        <v-tab>
          <v-icon size="30px">mdi-format-list-bulleted</v-icon>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" id="tab-items" touchless>
        <v-tab-item>
          <v-expansion-panels v-if="this.selectedBudget.client" accordion>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div class="client-info">
                  <div class="client-name">{{ this.selectedBudget.client.name }}</div>
                  <div class="client-vehicle">
                    {{ this.selectedBudget.service_order ? this.selectedBudget.service_order?.vehicle?.description : 'Veículo não informado' }}
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="client-details">
                  <div class="client-details-item">
                    <div class="client-details-item-title">Serviços</div>
                    <div class="client-details-item-value">{{ this.selectedBudget.client.service_orders_count }}</div>
                  </div>
                  <div class="client-details-item">
                    <div class="client-details-item-title">Cadastrado em</div>
                    <div class="client-details-item-value">{{ new Date(this.selectedBudget.client.created_at).toLocaleDateString() }}</div>
                  </div>
                  <div class="client-details-item">
                    <div class="client-details-item-title">Aniversário em</div>
                    <div class="client-details-item-value">
                      {{
                        this.selectedBudget.client.birthdate ? new Date(this.selectedBudget.client.birthdate).toLocaleDateString() : 'Não informado'
                      }}
                    </div>
                  </div>
                  <div class="client-details-item">
                    <div class="client-details-item-title">Contato</div>
                    <div class="client-details-item-value">
                      {{ this.selectedBudget.client.phone ? this.selectedBudget.client.phone : 'Não informado' }}
                    </div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <div class="rapid-actions">
            <div :class="{ 'rapid-actions-item': true, disabled: !this.selectedBudget.client }" @click="callClient()">
              <v-icon size="24px">mdi-phone</v-icon>
              <div class="rapid-actions-item-title">Ligar cliente</div>
            </div>
            <div
              :class="{ 'rapid-actions-item': true, disabled: !this.selectedBudget.client || !this.selectedBudget.service_order?.vehicle }"
              @click="sendBudget()"
            >
              <v-icon size="24px">mdi-file-document-outline</v-icon>
              <div class="rapid-actions-item-title">Enviar orçamento</div>
            </div>
            <div :class="{ 'rapid-actions-item': true, disabled: !this.selectedBudget.client }" @click="openWhatsApp()">
              <v-icon size="24px">mdi-whatsapp</v-icon>
              <div class="rapid-actions-item-title">WhatsApp cliente</div>
            </div>
            <div class="rapid-actions-item disabled">
              <v-icon size="24px">mdi-content-copy</v-icon>
              <div class="rapid-actions-item-title">Copiar link</div>
            </div>
          </div>
          <div class="change-status">
            <v-select
              v-model="selectedStatus"
              :items="status"
              hide-details
              outlined
              label="Status do orçamento"
              v-on:change="handleChangeStatus(selectedStatus)"
            ></v-select>
          </div>
          <div class="responsible">
            <v-text-field
              @click="isResponsibleSelectorModalActive = true"
              :v-model="responsible?.id"
              hide-details
              outlined
              readonly
              label="Responsável"
              append-icon="mdi-account"
              class="ma-0 pt-0"
              :value="responsible?.name"
            ></v-text-field>
          </div>
          <div class="visible-client" @click="handleToggleVisibleClient" :style="{ opacity: isVisibleClientLoading ? 0.6 : 1, pointerEvents: isVisibleClientLoading ? 'none' : 'auto' }">
            <span class="visible-client-label">Visível para o cliente:</span>
            <v-progress-circular v-if="isVisibleClientLoading" indeterminate size="20" width="2" color="#3d4451"></v-progress-circular>
            <v-chip
              v-else
              small
              :color="selectedBudget.visible_client ? '#48B38B' : '#3d4451'"
              text-color="#fff"
              class="visible-client-chip"
            >
              {{ selectedBudget.visible_client ? 'SIM' : 'NÃO' }}
            </v-chip>
          </div>
          <div class="services-products">
            <div class="sp-title">Serviços e produtos</div>
            <div class="sp-empty" v-if="!this.selectedBudget.budget_products.length && !this.selectedBudget.budget_services.length">
              <div class="sp-empty-text">Nenhum produto ou serviço adicionado</div>
            </div>
            <table style="width: 100%; border-collapse: separate; border-spacing: 0 10px">
              <tr v-for="item in this.selectedBudget.budget_services" :key="item.id">
                <td style="width: 40px; text-align: left; padding-left: 2px"><v-icon size="20px">mdi-tools</v-icon></td>
                <td>{{ item.service.description }}</td>
                <td style="width: 25px; text-align: center">{{ item.amount }}x</td>
                <td style="width: 94px; text-align: right">{{ formatCurrency(item.unitary_value) }}</td>
              </tr>
              <tr v-for="item in this.selectedBudget.budget_products" :key="item.id">
                <td style="width: 40px; text-align: left; padding-left: 2px"><v-icon size="20px">mdi-package-variant-closed</v-icon></td>
                <td>{{ item.product.description }}</td>
                <td style="width: 25px; text-align: center">{{ item.amount }}x</td>
                <td style="width: 94px; text-align: right">{{ formatCurrency(item.unitary_value) }}</td>
              </tr>
            </table>
          </div>
          <div class="amount-resume">
            <div class="resume-row">
              <span class="resume-label">Subtotal</span>
              <span class="resume-value">{{ subTotal }}</span>
            </div>

            <v-divider class="resume-divider"></v-divider>

            <div v-if="hasDiscount" class="resume-group">
              <div class="resume-row">
                <span class="resume-label">Desconto</span>
                <span class="resume-value discount-color">- {{ templateDiscount }}</span>
              </div>
              <div class="resume-breakdown">
                <div v-if="hasServicesDiscount" class="breakdown-item">
                  <span class="breakdown-label">Serviço</span>
                  <span class="breakdown-dots"></span>
                  <span class="breakdown-value">{{ servicesDiscountDisplay }}</span>
                </div>
                <div v-if="hasProductsDiscount" class="breakdown-item">
                  <span class="breakdown-label">Produto</span>
                  <span class="breakdown-dots"></span>
                  <span class="breakdown-value">{{ productsDiscountDisplay }}</span>
                </div>
                <div v-if="isLegacyMode" class="breakdown-item">
                  <span class="breakdown-label">Geral</span>
                  <span class="breakdown-dots"></span>
                  <span class="breakdown-value">{{ legacyDiscountDisplay }}</span>
                </div>
              </div>
            </div>

            <div v-if="hasEntryValue" class="resume-row">
              <span class="resume-label">Adiantamento</span>
              <span class="resume-value entry-color">- {{ entryValueDisplay }}</span>
            </div>

            <v-divider class="resume-divider"></v-divider>

            <div class="resume-row resume-total">
              <span class="resume-label">Total</span>
              <span class="resume-value">{{ total }}</span>
            </div>

            <div v-if="hasEntryValue" class="resume-row resume-remaining">
              <span class="resume-label">Restante a pagar</span>
              <span class="resume-value entry-color">{{ totalRemaining }}</span>
            </div>
          </div>
          <div v-if="this.selectedBudget.observation" class="observations">
            <div class="observations-title">Observações</div>
            <v-textarea v-model="this.selectedBudget.observation" hide-details rows="3" auto-grow disabled></v-textarea>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div v-if="this.selectedBudget.service_order">
            <v-carousel
              v-if="this.selectedBudget.service_order.service_order_photos.length"
              v-model="defaultSlide"
              height="300"
              class="service-order-photos"
            >
              <v-carousel-item v-for="(item, i) in this.selectedBudget.service_order.service_order_photos" :key="i" eager>
                <v-img
                  :src="minifyImage(item.photo_url)"
                  :lazy-src="minifyImage(item.photo_url)"
                  aspect-ratio="1"
                  class="grey lighten-2"
                  eager
                ></v-img>
              </v-carousel-item>
            </v-carousel>
            <div class="py-6 px-4">
              <v-btn block color="#48B38B" dark elevation="0" large @click="isServiceOrderSelectorModalActive = true">
                <span>Alterar Relatório de serviço</span>
              </v-btn>
            </div>
            <div class="service-order-information">
              <div class="principal">
                <div class="title">Informações básicas</div>
                <div class="body">
                  <div class="information">
                    <div class="icon">
                      <v-icon size="24px">mdi-file-document-outline</v-icon>
                    </div>
                    <div class="text">
                      <div class="item">Status</div>
                      <div class="value">{{ getServiceStatus(this.selectedBudget.service_order.status)?.title ?? 'Não informado' }}</div>
                    </div>
                  </div>
                  <div class="information">
                    <div class="icon">
                      <v-icon size="24px">mdi-clock-time-four-outline</v-icon>
                    </div>
                    <div class="text">
                      <div class="item">Previsão de entrega</div>
                      <div class="value">{{ handleForecastDate(this.selectedBudget.service_order.forecast_date) }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="this.selectedBudget.service_order.vehicle" class="vehicle">
                <div class="title">Veículo - {{ this.selectedBudget.service_order.vehicle.description }}</div>
                <div class="body">
                  <div class="information">
                    <div class="icon">
                      <v-icon size="24px">mdi-numeric</v-icon>
                    </div>
                    <div class="text">
                      <div class="item">Placa</div>
                      <div class="value">{{ this.selectedBudget.service_order.vehicle.vehicle_plate }}</div>
                    </div>
                  </div>
                  <div class="information">
                    <div class="icon">
                      <v-icon size="24px">mdi-car</v-icon>
                    </div>
                    <div class="text">
                      <div class="item">Marca</div>
                      <div class="value">
                        {{
                          this.selectedBudget.service_order.vehicle.vehicle_brand
                            ? this.selectedBudget.service_order.vehicle.vehicle_brand.description
                            : 'Não informada'
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="information">
                    <div class="icon">
                      <v-icon size="24px">mdi-counter</v-icon>
                    </div>
                    <div class="text">
                      <div class="item">Modelo</div>
                      <div class="value">
                        {{
                          this.selectedBudget.service_order.vehicle.year_model
                            ? this.selectedBudget.service_order.vehicle.year_model
                            : 'Não informado'
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="information">
                    <div class="icon">
                      <v-icon size="24px">mdi-counter</v-icon>
                    </div>
                    <div class="text">
                      <div class="item">Ano</div>
                      <div class="value">
                        {{ this.selectedBudget.service_order.vehicle.year ? this.selectedBudget.service_order.vehicle.year : 'Não informado' }}
                      </div>
                    </div>
                  </div>
                  <div class="information">
                    <div class="icon">
                      <v-icon size="24px">mdi-palette</v-icon>
                    </div>
                    <div class="text">
                      <div class="item">Cor</div>
                      <div class="value">
                        {{ this.selectedBudget.service_order.vehicle.color ? this.selectedBudget.service_order.vehicle.color : 'Não informada' }}
                      </div>
                    </div>
                  </div>
                  <div class="information">
                    <div class="icon">
                      <v-icon size="24px">mdi-gas-station</v-icon>
                    </div>
                    <div class="text">
                      <div class="item">Combustível</div>
                      <div class="value">
                        {{ this.selectedBudget.service_order.vehicle.fuel ? this.selectedBudget.service_order.vehicle.fuel : 'Não informado' }}
                      </div>
                    </div>
                  </div>
                  <div class="information">
                    <div class="icon">
                      <v-icon size="24px">mdi-car-settings</v-icon>
                    </div>
                    <div class="text">
                      <div class="item">Cilindrada</div>
                      <div class="value">
                        {{
                          this.selectedBudget.service_order.vehicle.engine_cc ? this.selectedBudget.service_order.vehicle.engine_cc : 'Não informada'
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="information">
                    <div class="icon">
                      <v-icon size="24px">mdi-car-settings</v-icon>
                    </div>
                    <div class="text">
                      <div class="item">Potência</div>
                      <div class="value">
                        {{
                          this.selectedBudget.service_order.vehicle.engine_cv ? this.selectedBudget.service_order.vehicle.engine_cv : 'Não informada'
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="information">
                    <div class="icon">
                      <v-icon size="24px">mdi-import</v-icon>
                    </div>
                    <div class="text">
                      <div class="item">Importado</div>
                      <div class="value">{{ this.selectedBudget.service_order.vehicle.imported ? 'Sim' : 'Não' }}</div>
                    </div>
                  </div>
                  <div class="information">
                    <div class="icon">
                      <v-icon size="24px">mdi-car-key</v-icon>
                    </div>
                    <div class="text">
                      <div class="item">Chassi</div>
                      <div class="value">
                        {{ this.selectedBudget.service_order.vehicle.chassi ? this.selectedBudget.service_order.vehicle.chassi : 'Não informado' }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="empty-state py-10">
            <img style="height: 130px; filter: grayscale(1); opacity: 0.6" :src="require('@/assets/add_os.png')" />
            <div class="pt-7 px-4">
              <v-btn block color="#48B38B" dark elevation="0" large @click="isServiceOrderSelectorModalActive = true">
                <span>Adicionar Relatório de serviço</span>
              </v-btn>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item>
          <v-card v-if="logsByDate.length" class="timeline-card">
            <div class="day" v-for="(log, index) in logsByDate" :key="index">
              <v-card light flat>
                <v-container class="day-container">
                  <v-layout align-center>
                    <strong class="display-1 font-weight-regular mr-4">{{ getDayNumber(log.date) }}</strong>
                    <v-layout column justify-end>
                      <div class="title font-weight-light">{{ getDayName(log.date) }}</div>
                      <div class="text-uppercase font-weight-light">{{ getMonthNameAndYear(log.date) }}</div>
                    </v-layout>
                  </v-layout>
                </v-container>
              </v-card>
              <v-card-text class="py-0">
                <v-timeline align-top dense v-for="(log, index) in log.logs" :key="index">
                  <v-timeline-item color="#D8D7DC" small>
                    <v-layout>
                      <v-flex>
                        <strong>{{ log.description }}</strong>
                        <div class="caption">
                          <strong>{{ getTime(log.created_at) }}</strong>
                          <span class="caption grey--text"> · </span>
                          <span class="caption grey--text">{{ log.user.name }}</span>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-timeline-item>
                </v-timeline>
              </v-card-text>
            </div>
          </v-card>
          <div v-else class="empty-state">
            <v-icon size="100px">mdi-timeline-clock-outline</v-icon>
            <div class="empty-state-text">Nenhum histórico encontrado</div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Excluir orçamento </v-card-title>
        <v-card-text> Tem certeza que deseja excluir este orçamento? Esta ação não poderá ser desfeita. </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="deleteDialog = false"> Cancelar </v-btn>
          <v-btn color="red darken-1" text @click="handleConfirmDelete"> Excluir </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay v-if="isLoading" absolute color="#48B38B">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-dialog v-model="duplicateDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Duplicar orçamento </v-card-title>
        <v-card-text> Tem certeza que deseja duplicar este orçamento? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="duplicateDialog = false"> Cancelar </v-btn>
          <v-btn color="primary" text @click="handleConfirmDuplicate"> Duplicar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="approveDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Aprovar orçamento </v-card-title>
        <v-card-text> Ao aprovar este orçamento você não poderá mais editá-lo. Tem certeza que deseja aprovar? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="cancelChangeStatus"> Cancelar </v-btn>
          <v-btn color="primary darken-1" text @click="handleConfirmApprove"> Aprovar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ManageDialog :is-active="isManageModalActive" @close="closeManageDialog" />

    <ServiceOrderSelector
      :isActive="isServiceOrderSelectorModalActive"
      @close="isServiceOrderSelectorModalActive = false"
      @select="handleSelectServiceOrder"
    />

    <ResponsibleSelector
      :isActive="isResponsibleSelectorModalActive"
      @close="isResponsibleSelectorModalActive = false"
      @select="handleSelectResponsible"
    />
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import Thumbor from 'thumbor-js-url-builder';
import BudgetService from '@/services/api/budget';
import BudgetLog from '@/services/api/budgetLogs';
import ManageDialog from '@/components/Budget/Manage';
import ServiceOrderSelector from '@/components/Budget/ServiceOrderSelector';
import ResponsibleSelector from '@/components/Budget/ResponsibleSelector';

export default {
  emits: ['close-dialog', 'delete-budget'],
  props: {
    dialog: Object
  },
  components: {
    ManageDialog,
    ServiceOrderSelector,
    ResponsibleSelector
  },
  mounted() {
    if (!this.selectedBudget.vehicle) {
      this.tab = 1;
    }
  },
  data() {
    return {
      isLoading: false,
      tab: 0,
      defaultSlide: 0,
      selectedStatus: null,
      responsible: null,
      status: [
        { value: 'pendente', text: 'Pendente' },
        { value: 'aguardando_aprovacao', text: 'Aguardando aprovação' },
        { value: 'aguardando_pagamento', text: 'Aguardando pagamento' },
        { value: 'em_andamento', text: 'Em andamento' },
        { value: 'aprovado', text: 'Aprovado' },
        { value: 'cancelado', text: 'Cancelado' },
        { value: 'recusado', text: 'Recusado' }
      ],
      logsByDate: [],
      deleteDialog: false,
      duplicateDialog: false,
      approveDialog: false,
      isManageModalActive: false,
      isServiceOrderSelectorModalActive: false,
      isResponsibleSelectorModalActive: false,
      isVisibleClientLoading: false
    };
  },
  computed: {
    ...mapState('Budget', ['selectedBudget']),
    service_status_list() {
      return this.$store.getters['General/organization_status_list'];
    },
    isLegacyMode() {
      if (!this.selectedBudget) return true;

      // Campos novos têm prioridade sobre os antigos
      const discountServices = this.selectedBudget.discount_services;
      const discountProducts = this.selectedBudget.discount_products;
      const discountTypeServices = this.selectedBudget.discount_type_services;
      const discountTypeProducts = this.selectedBudget.discount_type_products;

      const hasNewFields =
        (discountServices !== null && discountServices !== undefined) ||
        (discountProducts !== null && discountProducts !== undefined) ||
        (discountTypeServices !== null && discountTypeServices !== undefined && discountTypeServices !== '') ||
        (discountTypeProducts !== null && discountTypeProducts !== undefined && discountTypeProducts !== '');

      if (hasNewFields) return false;

      // Fallback para campos antigos
      const { discount, discount_type: discountType } = this.selectedBudget;

      const hasLegacyDiscount =
        discount !== null &&
        discount !== undefined &&
        discount !== '' &&
        discount !== 0 &&
        parseFloat(discount) > 0;

      const hasLegacyType =
        discountType !== null &&
        discountType !== undefined &&
        discountType !== '';

      return hasLegacyDiscount || hasLegacyType;
    },
    templateDiscount() {

      if (!this.selectedBudget) return this.formatCurrency(0);

      if(this.isLegacyMode) {
        return this.calculateDiscountLegacy()
      }
      
      return this.calculateDiscountNew().totalDiscount;
    },
    hasDiscount() {
      if (!this.selectedBudget) return false;
      if (this.isLegacyMode) {
        const discount = parseFloat(this.selectedBudget.discount) || 0;
        return discount > 0;
      }
      const discountServices = parseFloat(this.selectedBudget.discount_services) || 0;
      const discountProducts = parseFloat(this.selectedBudget.discount_products) || 0;
      return discountServices > 0 || discountProducts > 0;
    },
    servicesTotal() {
      if (!this.selectedBudget?.budget_services?.length) return 0;
      return this.selectedBudget.budget_services
        .filter((service) => service.disaproved_by_client !== true)
        .reduce((acc, service) => {
          const amount = parseInt(service.amount, 10) || 0;
          const unitaryValue = parseFloat(service.unitary_value) || 0;
          const totalValue = parseFloat(service.total_value) || 0;
          const calculatedTotal = amount * unitaryValue;
          return acc + (totalValue > 0 ? totalValue : calculatedTotal);
        }, 0);
    },
    productsTotal() {
      if (!this.selectedBudget?.budget_products?.length) return 0;
      return this.selectedBudget.budget_products
        .filter((product) => product.disaproved_by_client !== true)
        .reduce((acc, product) => {
          const amount = parseInt(product.amount, 10) || 0;
          const unitaryValue = parseFloat(product.unitary_value) || 0;
          const totalValue = parseFloat(product.total_value) || 0;
          const calculatedTotal = amount * unitaryValue;
          return acc + (totalValue > 0 ? totalValue : calculatedTotal);
        }, 0);
    },
    subTotal() {
      return this.formatCurrency(this.servicesTotal + this.productsTotal);
    },
    hasServicesDiscount() {
      if (!this.selectedBudget || this.isLegacyMode) return false;
      const discountServices = parseFloat(this.selectedBudget.discount_services) || 0;
      return discountServices > 0;
    },
    hasProductsDiscount() {
      if (!this.selectedBudget || this.isLegacyMode) return false;
      const discountProducts = parseFloat(this.selectedBudget.discount_products) || 0;
      return discountProducts > 0;
    },
    servicesDiscountDisplay() {
      if (!this.hasServicesDiscount) return '';
      const discountServices = parseFloat(this.selectedBudget.discount_services) || 0;
      const type = this.selectedBudget.discount_type_services;

      if (type === 'percentual') {
        const calculatedValue = this.servicesTotal * (discountServices / 100);
        return `${this.formatCurrency(calculatedValue)} (${discountServices}%)`;
      }
      return this.formatCurrency(discountServices);
    },
    productsDiscountDisplay() {
      if (!this.hasProductsDiscount) return '';
      const discountProducts = parseFloat(this.selectedBudget.discount_products) || 0;
      const type = this.selectedBudget.discount_type_products;

      if (type === 'percentual') {
        const calculatedValue = this.productsTotal * (discountProducts / 100);
        return `${this.formatCurrency(calculatedValue)} (${discountProducts}%)`;
      }
      return this.formatCurrency(discountProducts);
    },
    legacyDiscountDisplay() {
      if (!this.isLegacyMode || !this.hasDiscount) return '';
      const { discount, discount_type: discountType } = this.selectedBudget;

      if (discountType === 'percentual') {
        const subTotal = this.parseCurrency(this.subTotal);
        const calculatedValue = subTotal * (discount / 100);
        return `${this.formatCurrency(calculatedValue)} (${discount}%)`;
      }
      return this.formatCurrency(discount);
    },
    entryValueAmount() {
      if (!this.selectedBudget) return 0;
      const raw = this.selectedBudget.entry_value;
      if (raw === null || raw === undefined || raw === '') return 0;
      if (typeof raw === 'number') return raw;
      if (typeof raw === 'string' && (raw.includes('R$') || raw.includes(','))) {
        return this.parseCurrency(raw);
      }
      return parseFloat(raw) || 0;
    },
    hasEntryValue() {
      return this.entryValueAmount > 0;
    },
    entryValueDisplay() {
      if (!this.hasEntryValue) return '';
      return this.formatCurrency(this.entryValueAmount);
    },
    totalRemaining() {
      const totalValue = this.parseCurrency(this.total);
      return this.formatCurrency(totalValue - this.entryValueAmount);
    },
    isExtension() {
      return this.$route.query.mode === 'extension';
    }
  },
  watch: {
    'selectedBudget.id': {
      immediate: true,
      handler() {
        this.handleLogsByDate();
        this.selectedStatus = this.selectedBudget.status;
        this.responsible = this.selectedBudget.responsible;
      }
    },
    selectedBudget: {
      immediate: true,
      handler() {

        if(this.isLegacyMode) {
          this.discount = this.calculateDiscountLegacy();
        }
        else {
          this.discount = this.calculateDiscountNew()
        }

        this.total = this.calculateTotal();
      },
      deep: true
    }
  },
  methods: {
    openManageDialog() {
      this.isManageModalActive = true;
    },
    closeManageDialog() {
      this.isManageModalActive = false;
    },
    getServiceStatus(statusRef) {
      const status = this.service_status_list.find((status) => status.code === statusRef);
      return status;
    },
    closeDialog() {
      this.$emit('close-dialog', this.selectedBudget);
    },
    capitalized(string) {
      const capitalizedFirst = string[0].toUpperCase();
      const rest = string.slice(1);

      return capitalizedFirst + rest;
    },
    formatCurrency(value) {
      return value ? parseFloat(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00';
    },
    cancelChangeStatus() {
      this.selectedStatus = this.selectedBudget.status;
      this.approveDialog = false;
    },
    handleChangeStatus(status) {
      if (status === 'aprovado') {
        this.selectedStatus = status;
        this.approveDialog = true;
      } else {
        this.changeStatus(status);
      }
    },
    handleConfirmApprove() {
      this.changeStatus(this.selectedStatus);
    },
    changeStatus(status) {
      BudgetService.update(this.selectedBudget.id, { status }).then(() => {
        this.$store.commit('Budget/UPDATE_STATUS', status);

        const statusLabel = this.status.find((item) => item.value === this.selectedBudget.status).text;

        this.handleLog(`Orçamento alterado para ${statusLabel.toLowerCase()}`);

        this.handleLogsByDate();

        this.approveDialog = false;
      });
    },
    friendlyDate(date) {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);

      const dateToCompare = new Date(date);

      if (dateToCompare.toLocaleDateString() === today.toLocaleDateString()) {
        return `Hoje às ${dateToCompare.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
      }

      if (dateToCompare.toLocaleDateString() === yesterday.toLocaleDateString()) {
        return `Ontem às ${dateToCompare.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
      }

      return `${dateToCompare.toLocaleDateString()} às ${dateToCompare.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
    },
    handleLogsByDate() {
      BudgetLog.getByBudgetId(this.selectedBudget.id).then((response) => {
        const logs = response.data ? [...response.data] : [];

        const sortedLogs = logs.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        const logsByDate = [];

        sortedLogs.forEach((log) => {
          const date = new Date(log.created_at).toLocaleDateString();

          const index = logsByDate.findIndex((item) => item.date === date);

          if (index === -1) {
            logsByDate.push({
              date,
              logs: [log]
            });
          } else {
            logsByDate[index].logs.push(log);
          }
        });

        this.logsByDate = logsByDate;
      });
    },
    getDayNumber(date) {
      return date.split('/')[0];
    },
    getDayName(date) {
      const day = date.split('/')[0];
      const month = date.split('/')[1];
      const year = date.split('/')[2];

      const dateToCompare = new Date(`${year}-${month}-${day} 12:00:00`);

      const dayName = dateToCompare.toLocaleDateString('pt-BR', { weekday: 'long' });

      return this.capitalized(dayName);
    },
    getMonthNameAndYear(date) {
      const month = date.split('/')[1];
      const year = date.split('/')[2];

      const dateToCompare = new Date(`${year}-${month}-03`);

      const monthName = dateToCompare.toLocaleDateString('pt-BR', { month: 'long' });

      return `${monthName} de ${year}`;
    },
    getTime(dateTime) {
      const dataObj = new Date(dateTime);

      return dataObj.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    handleSelectResponsible(responsible) {
      BudgetService.update(this.selectedBudget.id, { responsible_id: responsible.id }).then(() => {
        this.$store.commit('Budget/UPDATE_RESPONSIBLE', responsible);

        this.responsible = responsible;

        this.handleLog('Responsável pelo orçamento alterado');

        this.handleLogsByDate();
      });
    },
    handleToggleVisibleClient() {
      if (this.isVisibleClientLoading) return;

      const newValue = !this.selectedBudget.visible_client;
      this.isVisibleClientLoading = true;

      BudgetService.update(this.selectedBudget.id, { visible_client: newValue }).then(() => {
        this.$store.commit('Budget/UPDATE_VISIBLE_CLIENT', newValue);

        this.handleLog(newValue ? 'Orçamento definido como visível para o cliente' : 'Orçamento definido como não visível para o cliente');

        this.handleLogsByDate();
      }).finally(() => {
        this.isVisibleClientLoading = false;
      });
    },
    openWhatsApp() {
      if (!this.selectedBudget.client?.phone) {
        return;
      }

      window.open(`whatsapp://send?phone=55${this.selectedBudget.client.phone.match(/\d+/g).join('')}`);
    },
    callClient() {
      if (!this.selectedBudget.client?.phone) {
        return;
      }

      window.open(`tel:${this.selectedBudget.client.phone.match(/\d+/g).join('')}`);
    },
    sendBudget() {
      if (!this.selectedBudget.client || !this.selectedBudget.service_order?.vehicle) {
        return;
      }

      let template = `
      ORÇAMENTO [Data]
------------------------------
*Cliente*:
- [Nome do Cliente]

*Veículo*:
- [[Placa do Carro]] [Modelo e Ano do Carro]
------------------------------
*Serviços*:
[Lista de Serviços]

*Produtos*:
[Lista de Produtos]
------------------------------
*Subtotal*: [Subtotal]
*Desconto*: [Desconto]
*Valor Final*: [Valor Final]
------------------------------
Formas de pagamento:
[Lista de Formas de Pagamento]
------------------------------
Condições de pagamento:
[Lista de Condições de Pagamento]
------------------------------
Observações gerais:
[Observações Gerais]
------------------------------
*[Sua Empresa]*
`;

      template = template.replace('[Data]', this.selectedBudget.date ? this.formatDate(this.selectedBudget.date) : 'Data não informada');
      template = template.replace('[Nome do Cliente]', this.selectedBudget.client.name);

      const { vehicle } = this.selectedBudget.service_order;
      const plate = vehicle.vehicle_plate?.toString().trim() || '';
      const description = vehicle.description?.toString().trim() || '';
      const year = vehicle.year?.toString().trim() || '';
      const yearModel = vehicle.year_model?.toString().trim() || '';
      const yearPart = year && yearModel ? `${year}/${yearModel}` : year || yearModel;
      const modelAndYear = [description, yearPart].filter(Boolean).join(' ');

      template = template.replace('[Placa do Carro]', plate);
      template = template.replace('[Modelo e Ano do Carro]', modelAndYear);

      if (this.selectedBudget.budget_services.length > 0) {
        template = template.replace(
          '[Lista de Serviços]',
          this.selectedBudget.budget_services
            .map((service) => `- ${service.amount}x [${this.formatCurrency(service.unitary_value)}] ${service.service.description}`)
            .join('\n')
        );
      } else {
        template = template.replace('[Lista de Serviços]', 'Nenhum serviço adicionado');
      }

      if (this.selectedBudget.budget_products.length > 0) {
        template = template.replace(
          '[Lista de Produtos]',
          this.selectedBudget.budget_products
            .map((product) => `- ${product.amount}x [${this.formatCurrency(product.unitary_value)}] ${product.product.description}`)
            .join('\n')
        );
      } else {
        template = template.replace('[Lista de Produtos]', 'Nenhum produto adicionado');
      }

      template = template.replace('[Subtotal]', this.subTotal);

      if (this.isLegacyMode) {
        template = template.replace('[Desconto]', this.discount);
      } else {
        template = template.replace('[Desconto]', this.formatDiscountForWhatsApp());
      }

      template = template.replace('[Valor Final]', this.total);

      if (this.hasEntryValue) {
        const valorFinalLine = `*Valor Final*: ${this.total}`;
        template = template.replace(
          valorFinalLine,
          `${valorFinalLine}\n*Adiantamento*: - ${this.entryValueDisplay}\n*Restante a pagar*: ${this.totalRemaining}`
        );
      }

      if (this.selectedBudget.budget_payment_methods.length > 0) {
        template = template.replace(
          '[Lista de Formas de Pagamento]',
          this.selectedBudget.budget_payment_methods.map((paymentMethod) => `- ${paymentMethod.description}`).join('\n')
        );
      } else {
        template = template.replace('[Lista de Formas de Pagamento]', 'Nenhuma forma de pagamento adicionada');
      }

      if (this.selectedBudget.budget_payment_conditions.length > 0) {
        template = template.replace(
          '[Lista de Condições de Pagamento]',
          this.selectedBudget.budget_payment_conditions.map((paymentCondition) => `- ${paymentCondition.description}`).join('\n')
        );
      } else {
        template = template.replace('[Lista de Condições de Pagamento]', 'Nenhuma condição de pagamento adicionada');
      }

      template = template.replace('[Observações Gerais]', this.selectedBudget?.observation || 'Nenhuma observação')
      template = template.replace('[Sua Empresa]', this.$store.getters['Auth/user'].organization.name);

      if (this.isExtension) {
        window.open(
          `https://api.whatsapp.com/send?phone=55${this.selectedBudget.client.phone.match(/\d+/g).join('')}&text=${encodeURIComponent(template)}`
        );
      } else {
        window.open(`whatsapp://send?phone=55${this.selectedBudget.client.phone.match(/\d+/g).join('')}&text=${encodeURIComponent(template)}`);
      }
    },
    minifyImage(photo) {
      const thumbor = new Thumbor('y37r666f2300d9gkf', 'https://thumbnail.checkmotors.net');

      return thumbor.setImagePath(photo).resize(300, 0).buildUrl();
    },
    getOS() {
      const uA = navigator.userAgent || navigator.vendor || window.opera;
      if ((/iPad|iPhone|iPod/.test(uA) && !window.MSStream) || (uA.includes('Mac') && 'ontouchend' in document)) return 'iOS';
      return null;
    },
    handleForecastDate(date) {
      if (date) {
        const day = date.split('-')[2].split('T')[0];
        const month = date.split('-')[1];
        const year = date.split('-')[0];

        const dateToCompare = new Date(`${year}-${month}-${day} 12:00:00`);

        const dayName = dateToCompare.toLocaleDateString('pt-BR', { weekday: 'long' });
        const monthName = dateToCompare.toLocaleDateString('pt-BR', { month: 'long' });

        return `${this.capitalized(dayName)}, ${day} de ${this.capitalized(monthName)}`;
      }

      return 'Não informada';
    },
    deleteBudget() {
      this.deleteDialog = true;
    },
    handleConfirmDelete() {
      this.deleteDialog = false;
      this.isLoading = true;
      BudgetService.inactivate(this.selectedBudget.id).then(() => {
        this.handleLog('Orçamento excluído');
        this.isLoading = false;
        this.$emit('delete-budget', this.selectedBudget.id);
        this.closeDialog();
      });
    },
    handleLog(message) {
      this.$store.commit('Budget/ADD_LOG', {
        description: message,
        createdAt: new Date().toISOString(),
        user: this.$store.getters['Auth/user']
      });
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
    calculateTotal() {
      const subTotal = this.parseCurrency(this.subTotal);
      let discount = 0

      if(this.isLegacyMode) {
        discount = this.calculateDiscountLegacy();
      }
      else {
        discount = this.calculateDiscountNew().totalDiscount
      }

      return this.formatCurrency(subTotal - this.parseCurrency(discount));
    },
    calculateDiscountLegacy() {

      if (!this.selectedBudget?.discount) return this.formatCurrency(0);

      const subTotal = this.parseCurrency(this.subTotal);
      const discountType = this.selectedBudget?.discount_type;
      const discount = this.selectedBudget?.discount;

      if (discount) {
        return discountType === 'percentual'
          ? this.formatCurrency(subTotal * (discount / 100))
          : this.formatCurrency(discount);
      }

      return this.formatCurrency(0);
    },
    calculateDiscountNew() {

      let serviceDiscount = 0
      let productDiscount = 0

      const discountServices = parseFloat(this.selectedBudget.discount_services) || 0;
      const discountTypeServices = this.selectedBudget.discount_type_services;

      if (discountServices > 0) {
        serviceDiscount =
          discountTypeServices === 'percentual'
            ? this.servicesTotal * (discountServices / 100)
            : discountServices;
      }

      const discountProducts = parseFloat(this.selectedBudget.discount_products) || 0;
      const discountTypeProducts = this.selectedBudget.discount_type_products;

      if (discountProducts > 0) {
        productDiscount =
          discountTypeProducts === 'percentual'
            ? this.productsTotal * (discountProducts / 100)
            : discountProducts;
      }

      return {
        serviceDiscount: this.formatCurrency(serviceDiscount),
        productDiscount: this.formatCurrency(productDiscount),
        totalDiscount: this.formatCurrency(serviceDiscount + productDiscount)
      };
    },
    formatDiscountForWhatsApp() {
      if (!this.hasDiscount) {
        return this.formatCurrency(0);
      }

      const { totalDiscount } = this.calculateDiscountNew();
      const lines = [totalDiscount];

      if (this.hasServicesDiscount) {
        lines.push(`- Serviços: ${this.servicesDiscountDisplay}`);
      }
      if (this.hasProductsDiscount) {
        lines.push(`- Produtos: ${this.productsDiscountDisplay}`);
      }

      return lines.join('\n');
    },
    parseCurrency(value) {
      return value ? parseFloat(value.replace('R$', '').replace('.', '').replace(',', '.').trim()) : 0;
    },
    handleSelectServiceOrder(serviceOrder) {
      if (this.selectedBudget.service_order) {
        this.handleLog(`Relatório de serviço alterada para #${serviceOrder.number}`);
      } else {
        this.handleLog(`Relatório de serviço adicionada #${serviceOrder.number}`);
      }

      this.$store.commit('Budget/UPDATE_SERVICE_ORDER', serviceOrder);
    },
    duplicateBudget() {
      this.duplicateDialog = true;
    },
    handleConfirmDuplicate() {
      this.duplicateDialog = false;
      this.isLoading = true;

      BudgetService.duplicate(this.selectedBudget.id).then((response) => {
        const pastBudgetId = this.selectedBudget.id;

        this.isLoading = false;
        this.$store.commit('Budget/SET_SELECTED_BUDGET', response.data.budget);

        this.handleLog(`Duplicado do orçamento #${pastBudgetId}`);

        this.$toast.success('Orçamento duplicado com sucesso');
      });
    },
    calculateDiscountResume() {
      const subTotal = this.parseCurrency(this.subTotal);
      const discount = this.parseCurrency(this.calculateDiscountLegacy());

      const discountResume = subTotal > 0 ? (discount * 100) / subTotal : 0;

      return discountResume ? `(${discountResume.toFixed(2)}%)` : '';
    }
  }
};
</script>

<style lang="scss" scoped>
button.v-btn.v-btn--icon.v-btn--round.theme--dark.v-size--default {
  margin-right: 0 !important;
}

#tab-items {
  background-color: transparent !important;
}

.flex.xs3 {
  min-width: 72px !important;
}

.empty-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.6);
  background-color: #fff;
  margin: 20px;
  overflow-y: auto;
  padding-top: 28px;
  border-radius: 6px;

  .empty-state-text {
    font-size: 16px;
    margin-top: 16px;
    background-color: #f0eff5;
    padding: 10px;
    border-radius: 6px;
  }
}

.day-container {
  background: #f0eff5;
  padding-left: 47px;
}

.timeline-card {
  margin-top: 3px;
}

.v-expansion-panel::before {
  box-shadow: none !important;
}

.client-details {
  .client-details-item {
    display: flex;
    margin-bottom: 8px;
    justify-content: space-between;

    .client-details-item-title {
      font-weight: bold;
      color: rgba(0, 0, 0, 0.6);
    }

    .client-details-item-value {
      color: rgba(0, 0, 0, 0.6);
    }
  }
}

.rapid-actions {
  padding: 0px 10px;
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  gap: 5px;
  overflow: scroll;

  .rapid-actions-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 30% !important;
    height: 100px;
    border-radius: 8px;
    background-color: #fff;
    border: 2px solid #e1e1e1;
    cursor: pointer;
    padding: 10px 10px 10px 10px;

    i {
      color: #9c9c9c;
      display: flex;
      justify-content: flex-start;
    }

    .rapid-actions-item-title {
      font-size: 12px;
      color: #4f4f4f;
      margin-top: 8px;
    }
  }

  .rapid-actions-item.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.rapid-actions::-webkit-scrollbar {
  display: none;
}

.rapid-actions-item:active {
  background-color: #f0eff5;
}

.v-expansion-panels {
  margin-top: 3px;
}

.service-order-photos {
  margin-top: 3px;
}

.service-order-information {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .principal,
  .vehicle {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .title {
      margin-left: 16px;
    }

    .body {
      background: white;
      padding: 16px 16px;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
  }

  .information {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;

    .text {
      .item {
        color: #9f9f9f;
        font-size: 14px;
      }

      .value {
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
}

.budget-details {
  color: rgba(0, 0, 0, 0.6) !important;
  background-color: #f0eff5 !important;
  overflow-y: auto;
  padding-top: 69px;

  .top-bar {
    top: 0;
    width: 100%;
    z-index: 999;
    overflow: hidden;
    padding: 4px 10px;
    background-color: #fff;
    border-bottom: 1px solid #d9d8de;
    position: absolute;

    .right-actions {
      float: right;
      margin-top: 2px;
    }

    .action {
      border: 1px solid #c8c8c8;
      padding: 8px;
      margin: 8px;
      float: left;
      border-radius: 6px;
    }
  }

  .header {
    min-height: 100px;
    position: relative;
    margin: 22px 20px;
    width: auto;

    .total-value {
      font-size: 30px;
      font-weight: bold;
    }

    .header-actions {
      bottom: 0px;
      position: absolute;
      width: 100%;
    }
  }

  .client-info {
    float: left;
    padding-top: 1px;

    .client-name {
      font-size: 17px;
      font-weight: 400;
      color: #111b21;
    }

    .client-vehicle {
      font-weight: 400;
      font-size: 13px;
      margin-top: 6px;
      color: #667781;
    }
  }

  .change-status {
    background-color: #fff;
    padding: 20px;

    margin-top: 15px;
  }

  .responsible {
    background-color: #fff;
    padding: 20px;

    margin: 15px 0 0 0;
  }

  .visible-client {
    margin-top: 15px !important;
    background-color: #fff;
    padding: 14px 20px;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    cursor: pointer;
    border-top: 1px solid #e8e8e8;

    .visible-client-label {
      font-size: 15px;
      color: #4f4f4f;
    }

    .visible-client-chip {
      font-weight: 600;
      letter-spacing: 0.5px;
    }
  }

  .observations {
    background-color: #fff;
    padding: 20px;

    margin-top: 15px;
    margin-bottom: 15px;

    .observations-title {
      font-size: 17px;
      font-weight: 400;
      color: #111b21;
    }

    .observations-text {
      font-size: 14px;
      font-weight: 400;
      color: #667781;
    }
  }

  .services-products {
    background-color: #fff;
    padding: 12px 20px;
    margin-top: 15px;

    .sp-title {
      padding-bottom: 8px;
      border-bottom: 1px solid #c8c8c8;
      font-size: 17px;
      font-weight: 400;
      color: #111b21;
    }

    .sp-empty {
      text-align: center;
      padding: 20px;
      padding-top: 27px;

      .sp-empty-text {
        font-size: 14px;
        font-weight: 400;
        color: #667781;
      }
    }
  }

  .amount-resume {
    background: white;
    padding: 16px 20px !important;
    margin-top: 10px;
    margin-bottom: 10px;

    .resume-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 7px 0;

      .resume-label {
        font-size: 14px;
        color: #4a5568;
      }

      .resume-value {
        font-size: 14px;
        font-weight: 500;
        color: #2d3748;
      }
    }

    .resume-group {
      margin: 2px 0;
    }

    .resume-breakdown {
      padding: 2px 0 6px 14px;

      .breakdown-item {
        display: flex;
        align-items: center;
        padding: 3px 0;

        .breakdown-label {
          font-size: 12px;
          color: #a0aec0;
          min-width: 52px;
        }

        .breakdown-dots {
          flex: 1;
          border-bottom: 1px dotted #e2e8f0;
          margin: 0 8px;
          height: 1px;
        }

        .breakdown-value {
          font-size: 12px;
          font-weight: 500;
          color: #a0aec0;
        }
      }
    }

    .discount-color {
      color: #e53e3e !important;
    }

    .entry-color {
      color: #48b38b !important;
    }

    .resume-divider {
      margin: 6px 0;
    }

    .resume-total {
      padding-top: 10px;

      .resume-label {
        font-size: 17px;
        font-weight: 600;
        color: #1a202c;
      }

      .resume-value {
        font-size: 17px;
        font-weight: 700;
        color: #1a202c;
      }
    }

    .resume-remaining {
      padding: 2px 0 0 0;

      .resume-label {
        font-size: 13px;
        color: #a0aec0;
      }

      .resume-value {
        font-size: 13px;
        font-weight: 600;
      }
    }
  }
}
</style>
